// Landing copy and markup. Every promise here matches the real PDFs (6 x 30 pages + 4 x 20 pages).
import { I } from './images';

export const PAGE_HTML = `
<header class="top">
  <div class="wrap">
    <div class="brand">The Argentine Mate Experience</div>
    <a class="mini" href="#offer">Get it — $19</a>
  </div>
</header>

<section class="hero">
  <div class="wrap grid">
    <div>
      <div class="eyebrow">6 visual guidebooks + 4 bonuses · PDF</div>
      <h1 style="margin-top:12px">Make your first Argentine mate <em>with confidence</em></h1>
      <p class="lead">A beautifully illustrated collection that walks curious beginners through the story, the preparation, the tools, the yerba and the everyday ritual of mate, one clear step at a time.</p>
      <ul class="ticks">
        <li>260 illustrated pages, written in plain English</li>
        <li>From your first pour to sharing mate like a local</li>
        <li>Instant download. Read on phone, tablet or print it</li>
      </ul>
      <div class="priceline"><span class="now">$19</span><span class="tag">260 pages, all included · one-time payment</span></div>
      <a class="btn" href="#offer" data-buy>Get instant access →</a>
    </div>
    <div class="img"><img src="${I.hero}" width="1200" height="1200" alt="Mate gourd, thermos and Volume 1 of The Argentine Mate Experience on a wooden table"></div>
  </div>
</section>

<div class="strip">
  <div class="wrap">
    <ul>
      <li>100% digital PDF</li>
      <li>Instant access</li>
      <li>Made for beginners</li>
      <li>Printable worksheets</li>
    </ul>
  </div>
</div>

<section>
  <div class="wrap center">
    <div class="eyebrow">Sound familiar?</div>
    <h2 style="margin-top:10px">Mate looks simple. The first time, it isn't.</h2>
    <div class="qs">
      <div class="q">Which mate and bombilla should I buy?</div>
      <div class="q">How hot should the water be?</div>
      <div class="q">Why does my mate taste so bitter?</div>
      <div class="q">What do I do when someone offers me one?</div>
    </div>
    <p style="max-width:620px;margin:0 auto;color:var(--muted)">This collection answers those questions with pictures, not long paragraphs. Every page shows you exactly what to do, so you can stop guessing and start enjoying it.</p>
  </div>
</section>

<section style="padding-top:0">
  <div class="wrap">
    <div class="center">
      <div class="eyebrow">What's inside</div>
      <h2 style="margin-top:10px">Six guidebooks, 30 pages each</h2>
      <p>Each volume covers one part of the ritual, so you can read them in order or jump straight to what you need.</p>
    </div>
    <div class="vols">
      <div class="vol"><img src="${I.tomo1}" width="520" height="673" alt="Volume 1 cover" loading="lazy"><div><div class="n">Volume 1</div><h3>The Story of Argentine Mate</h3><p>Where mate comes from, the words you'll hear, and why it matters so much in Argentine daily life.</p></div></div>
      <div class="vol"><img src="${I.tomo2}" width="520" height="651" alt="Volume 2 cover" loading="lazy"><div><div class="n">Volume 2</div><h3>The Perfect Mate Ritual</h3><p>The full preparation in 7 steps: filling, the yerba slope, water temperature, the first pour and refills.</p></div></div>
      <div class="vol"><img src="${I.tomo3}" width="520" height="673" alt="Volume 3 cover" loading="lazy"><div><div class="n">Volume 3</div><h3>Choose Your Mate</h3><p>Calabash, wood, ceramic, glass or steel. Which vessel and bombilla fit your routine, and how to care for them.</p></div></div>
      <div class="vol"><img src="${I.tomo4}" width="520" height="673" alt="Volume 4 cover" loading="lazy"><div><div class="n">Volume 4</div><h3>Yerba Selection and Storage</h3><p>Con palo, sin palo, smooth or bold. How to pick a yerba you'll enjoy and keep it fresh.</p></div></div>
      <div class="vol"><img src="${I.tomo5}" width="520" height="673" alt="Volume 5 cover" loading="lazy"><div><div class="n">Volume 5</div><h3>Share Mate Like a Local</h3><p>The round, the cebador, saying "gracias" and the small rules that make sharing mate feel natural.</p></div></div>
      <div class="vol"><img src="${I.tomo6}" width="520" height="673" alt="Volume 6 cover" loading="lazy"><div><div class="n">Volume 6</div><h3>Your Seven Day Mate Practice</h3><p>One small, guided mate each day for a week, with worksheets to find your own way of preparing it.</p></div></div>
    </div>
  </div>
</section>

<section class="inside">
  <div class="wrap">
    <div class="center">
      <div class="eyebrow">Look inside</div>
      <h2 style="margin-top:10px">Real pages from the collection</h2>
      <p>No filler. Every page is designed to be useful.</p>
    </div>
    <div class="rail" aria-label="Sample pages">
      <figure><img src="${I.page1}" width="760" height="984" alt="Volume 1 page: Speaking Mate vocabulary" loading="lazy"><figcaption>Vol. 1 · Speaking Mate</figcaption></figure>
      <figure><img src="${I.page2}" width="760" height="951" alt="Volume 2 page: The ritual in seven steps" loading="lazy"><figcaption>Vol. 2 · The ritual in seven steps</figcaption></figure>
      <figure><img src="${I.page3}" width="760" height="984" alt="Volume 3 page: Find your match" loading="lazy"><figcaption>Vol. 3 · Find your match</figcaption></figure>
      <figure><img src="${I.page4}" width="760" height="984" alt="Volume 4 page: Find your yerba direction" loading="lazy"><figcaption>Vol. 4 · Find your yerba direction</figcaption></figure>
      <figure><img src="${I.page5}" width="760" height="984" alt="Volume 5 page: Small rules, warmer moments" loading="lazy"><figcaption>Vol. 5 · Small rules, warmer moments</figcaption></figure>
      <figure><img src="${I.page6}" width="760" height="984" alt="Volume 6 page: A simple path to your own ritual" loading="lazy"><figcaption>Vol. 6 · A simple path to your own ritual</figcaption></figure>
    </div>
    <p class="hint center">Swipe to see more →</p>
  </div>
</section>

<section>
  <div class="wrap">
    <div class="center">
      <div class="eyebrow">Included free</div>
      <h2 style="margin-top:10px">Plus 4 practical bonuses</h2>
      <p>20 pages each, made to help you put the ritual into practice.</p>
    </div>
    <div class="bonus-grid">
      <div class="bonus"><img src="${I.bono1}" width="420" height="544" alt="Bonus 1 cover" loading="lazy"><div class="n">Bonus 1</div><h3>The Quick Start Combo</h3><p>Your first mate in 10 minutes, with a one-page 7-step method.</p></div>
      <div class="bonus"><img src="${I.bono2}" width="420" height="544" alt="Bonus 2 cover" loading="lazy"><div class="n">Bonus 2</div><h3>The Essential Starter Kit</h3><p>A printable buying guide for your first mate, bombilla, yerba and thermos.</p></div>
      <div class="bonus"><img src="${I.bono3}" width="420" height="544" alt="Bonus 3 cover" loading="lazy"><div class="n">Bonus 3</div><h3>The Flavor Pairing Bundle</h3><p>Sweet and savory foods that go with each style of yerba.</p></div>
      <div class="bonus"><img src="${I.bono4}" width="420" height="544" alt="Bonus 4 cover" loading="lazy"><div class="n">Bonus 4</div><h3>The 30-Day Mate Mega Pack</h3><p>Thirty small daily actions and a tracker to build your own ritual.</p></div>
    </div>
  </div>
</section>

<section style="padding-top:0">
  <div class="wrap">
    <div class="center"><h2>Is this for you?</h2></div>
    <div class="fit">
      <div class="card yes">
        <h3>A great fit if you…</h3>
        <ul>
          <li>Bought a mate and aren't sure how to use it</li>
          <li>Tried mate once and want to make it properly</li>
          <li>Love Argentine culture, or have Argentine friends</li>
          <li>Want a calm, screen-free ritual for your day</li>
          <li>Are looking for a thoughtful gift for a mate lover</li>
        </ul>
      </div>
      <div class="card no">
        <h3>Not for you if you…</h3>
        <ul>
          <li>Expect a physical mate or yerba (this is a digital guide)</li>
          <li>Are looking for health or medical advice</li>
          <li>Already prepare mate every day like an Argentine</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="offer" id="offer">
  <div class="wrap center">
    <div class="eyebrow">The complete collection</div>
    <h2 style="margin-top:10px">Everything you need to begin</h2>
    <div class="box">
      <div class="stack" aria-hidden="true">
        <img src="${I.tomo1}" alt="" style="left:0;top:26px;transform:rotate(-8deg)">
        <img src="${I.tomo4}" alt="" style="left:78px;top:6px;z-index:2">
        <img src="${I.tomo2}" alt="" style="left:156px;top:26px;transform:rotate(8deg)">
      </div>
      <ul class="list">
        <li><span>6 main guidebooks</span><span>180 pages</span></li>
        <li><span>4 practical bonuses</span><span>80 pages</span></li>
        <li><span>Printable worksheets and field cards</span><span>included</span></li>
        <li><span>Download and keep every PDF</span><span>included</span></li>
      </ul>
      <div class="priceline"><span class="now">$19</span></div>
      <p class="fine" style="margin:-8px 0 18px">All 10 PDFs, 260 pages · One-time payment · No subscription</p>
      <a class="btn block" href="#offer" data-buy>Get instant access →</a>
      <p class="fine" style="margin-top:14px">Secure checkout · Instant digital delivery · English edition</p>
    </div>
  </div>
</section>

<section>
  <div class="wrap" style="max-width:760px">
    <div class="center"><h2>Questions</h2></div>
    <details><summary>Is this a physical product?</summary><p>No. The Argentine Mate Experience is a digital PDF collection. Nothing is shipped. You'll still need your own mate, bombilla, yerba and hot water to practice.</p></details>
    <details><summary>I've never had mate. Is this too advanced?</summary><p>It's written for complete beginners. Volume 2 and Bonus 1 take you through your very first preparation step by step.</p></details>
    <details><summary>How do I receive it?</summary><p>Right after payment you get access to download all the PDFs.</p></details>
    <details><summary>Can I read it on my phone?</summary><p>Yes. The PDFs open on any phone, tablet or computer, and the worksheets can be printed on standard paper.</p></details>
    <details><summary>What language is it in?</summary><p>English. Spanish terms like cebador, bombilla or con palo are explained the first time they appear.</p></details>
    <details><summary>Do I need to buy special equipment first?</summary><p>No. Volume 3 and Bonus 2 help you choose a simple first setup before you spend money on accessories.</p></details>
  </div>
</section>

<section class="final">
  <div class="wrap center">
    <h2>Your first good mate can be today</h2>
    <p style="margin:14px auto 26px;max-width:540px">Learn the ritual, find the yerba you like and make it part of your day.</p>
    <a class="btn" href="#offer">Get the collection for $19 →</a>
  </div>
</section>

<footer>
  <div class="wrap">
    The Argentine Mate Experience · Digital product · All rights reserved
  </div>
</footer>

<div class="sticky" id="sticky">
  <div class="p">$19<small>260 pages</small></div>
  <a class="btn" href="#offer">Get instant access</a>
</div>
`;
